// extracted by mini-css-extract-plugin
module.exports = {"action-link":"style_action-link__2CpgL","total-font":"style_total-font__3UIw-"};